import { IDeckCardDetails } from '@/courses/interfaces/deck-library.interfaces';
import { Section } from '@/courses/models/section.model';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-deck-cards-navigation',
  components: {
    EdDeckCardSide: () => import(/* EdDeckCardSide */'../ed-deck-card-side/ed-deck-card-side.component.vue'),
  }
})
export default class EdDeckCardsNavigationComponent extends Vue {
  @Prop({ default: () => [] }) readonly cards: IDeckCardDetails[];

  get cardsList() {
    return this.cards.map((card) => {
      return {
        ...card,
        frontSide: card.data.sections[0],
        backSide: card.data.sections[1],
      };
    });
  }

  getIsLegacyCard(card: Section): boolean {
    return card.sections[0].type !== 'CARD_DESIGNER';
  }

  triggerOnAddCard() {
    this.$emit('onAddCard');
  }

  selectCardSide(card: Section, isFlipped: boolean) {
    this.$emit('onFlipCard', {
      card,
      isFlipped,
    });
  }
}